const DENMARK_MARKET = 'DK'
const AUSTRIA_MARKET = 'AT'
const TRANSITION_MARKETS = [DENMARK_MARKET, AUSTRIA_MARKET]

function getTransitionExperimentationKey (market) {
  return `merchant-support-chat.freshchat-group-transition-${market.toLowerCase()}`
}

function mustAsignToInternalTeam ({ features, market }) {
  const marketExpKey = getTransitionExperimentationKey(market)
  if (!features?.[marketExpKey]?.is_enabled) {
    return false
  }

  const value = features[marketExpKey].is_enabled

  return value === 'true'
}

function generateTag ({ market, features }) {
  if (!market || typeof market !== 'string') {
    throw Error('A correct market is required to open a new chat window.')
  }

  if (
    TRANSITION_MARKETS.includes(market) &&
    mustAsignToInternalTeam({ features, market })
  ) {
    return `merchantportal-${market.toLowerCase()}-transition`
  }

  return `merchantportal-${market.toLowerCase()}`
}

export default generateTag
